// dropdown
/* eslint-env jquery */

import URI from 'urijs';

const currentUrl = window.location.href;
// const getDomainName = window.location.hostname;
const productCookieName = 'smacon';
const HeaderMenu = {
  onHover: () => {
    (function ($) {
      $('.dropdown-toggle').on({
        mouseenter: function () {
          $(this).closest('.headerMenuWrapper').addClass('headerMenuStyle');
        },
        mouseleave: function () {
          $(this).closest('.headerMenuWrapper').removeClass('headerMenuStyle');
        },
      });

      const navs = document.querySelectorAll('nav > a > span');
      navs.forEach((nav) => {
        nav.addEventListener('mouseover', (n) => {
          const panel = document.getElementById(n.target.getAttribute('data-target'));

          $('nav > a').removeClass('active');
          $(n.target).parent().addClass('active');

          document.querySelectorAll('.pane').forEach((pane) => {
            // pane.className = pane.className.replace(' show active', '');
            $(pane).removeClass('show active');
          });
          if (panel) {
            $(panel).addClass('show active');
            // navpanel.className += ' active';
          }
        });
      });
    })(jQuery);
  },
  onClickEvent: () => {
    (function ($) {
      $('.navbar-collapse .nav-link').click((e) => {
        e.stopPropagation();
      });
    })(jQuery);
  },
  onScreenSizeChange: () => {
    const breakMenuPoint = 992;
    const windowWidth = window.innerWidth;
    $('#menu-products .menu-item > div').toggleClass('dropdown-menu', windowWidth < breakMenuPoint);
  },
  onResize: () => {
    (function ($) {
      // Call on load
      HeaderMenu.onScreenSizeChange();

      // Call on resize
      $(window).on('resize', function () {
        HeaderMenu.onScreenSizeChange();
      });
    })(jQuery);
  },
  //This will ensure the smacon data is parsed safely
  parseSmacon: (smacon) => {
    let parsedSmacon = {};
    try {
      parsedSmacon = JSON.parse(decodeURIComponent(atob(smacon)));
    } catch (err) {
      console.error(err);
      parsedSmacon = {};
    } finally {
      // eslint-disable-next-line no-unsafe-finally
      return parsedSmacon;
    }
  },
  fetchUserWalletBalance: (apiKey) => {
    (function ($) {
      if (apiKey) {
        $.ajax({
          // url: 'https://qa-api.gupshup.io/sm/api/v2/wallet/WHATSAPP/balance',
          url: 'https://api.gupshup.io/sm/api/v2/wallet/WHATSAPP/balance',
          type: 'get',
          data: {
            apikey: apiKey,
            authorization: apiKey,
          },
          success: function (response) {
            if (Object.prototype.hasOwnProperty.call(response, 'message')) {
              const { currentBalance, currency, skipDeduction } = response.message;
              if (skipDeduction === false) {
                $('.walletBilling').html(`My Wallet <span class='walletCta'>${currentBalance} ${currency}</span>`);
              } else if (skipDeduction === true) {
                $('.walletBilling').text('Billing');
              }
            }
          },
          error: function (xhr) {
            if (xhr.status) {
              console.log('An error occurred in fetching balance');
            }
          },
        });
      } else {
        console.log('Error! Api Key Not Found.');
      }
    })(jQuery);
  },
  onProductLogin: () => {
    const uri = new URI(currentUrl);
    const localUrls = ['localhost', 'gupshup.local'];
    const isLocal = localUrls.includes(window.location.hostname) ? true : false;
    let getUserInfo = Cookies.get(productCookieName);

    if (isLocal) {
      // Get cookie from URL query param
      const queryParams = uri.search(true);
      if (!getUserInfo) {
        ({ smacon: getUserInfo = '' } = queryParams);
        Cookies.set('smacon', getUserInfo);
      }
    }

    // trigger an api query
    HeaderMenu.getParsedCookieInfoFromApi()
      .then((userInfo) => {
        // Handle the response data here
        if (Object.prototype.hasOwnProperty.call(userInfo, 'userId')) {
          $('#product-dashboard-menu').show();
          $('.user-login-cta').show();
          $('#productMobileLogout').show();
          if (Object.prototype.hasOwnProperty.call(userInfo, 'profilePic')) {
            const userImage = $('.userAvatar img');
            userImage.attr('src', userInfo.profilePic);
            userImage.show();
          } else {
            $('.userAvatar img').remove();
            $('.userAvatar img').html("<span class='userInitials'>" + userInfo.username.toUpperCase()) + '</span>';
          }
          $('#userLogin li:nth-child(1)').text(Object.prototype.hasOwnProperty.call(userInfo, 'username') ? userInfo.username : '-');
          $('.productUserName').text(Object.prototype.hasOwnProperty.call(userInfo, 'username') ? userInfo.username : '-');
          if (Object.prototype.hasOwnProperty.call(userInfo, 'apikey')) {
            $('#product-api-key').text(userInfo.apikey);
            // Based on the apiKey in the cookie fetch user wallet balance
            HeaderMenu.fetchUserWalletBalance(userInfo.apikey);
          } else {
            $('#product-api-key').text('-');
          }
        }
      })
      .catch((error) => {
        console.error('Request failed:', error);
        // hide signedin menu
        HeaderMenu.loggedOutUserDisplay();
      });
  },

  loggedOutUserDisplay: () => {
    $('.product-login-btn').show();
    $('.loginStickyCtaBtn').show();
    $('.user-login-cta').hide();
    $('#productMobileLogout').hide();
    $('#product-dashboard-menu').hide();
  },

  getParsedCookieInfoFromApi: () => {
    return new Promise((resolve, reject) => {
      $.ajax({
        url: 'https://api.gupshup.io/sm/api/user',
        xhrFields: {
          withCredentials: true,
        },
        type: 'GET',
        success: function (responseData) {
          // Resolve the promise with the response data
          resolve(responseData);
        },
        error: function (jqXHR, textStatus, errorThrown) {
          // Reject the promise with the error details
          reject({
            jqXHR,
            textStatus,
            errorThrown,
          });
        },
      });
    });
  },

  onProductLogOut: () => {
    HeaderMenu.getParsedCookieInfoFromApi().then((userInfo) => {
      if (Object.prototype.hasOwnProperty.call(userInfo, 'apikey')) {
        // console.log('logging out');

        (function ($) {
          $.ajax({
            url: 'https://api.gupshup.io/sm/api/user/logout',
            headers: {
              apikey: userInfo.apikey,
            },
            xhrFields: {
              withCredentials: true,
            },
            type: 'POST',
            success: function () {
              $('.product-login-btn').show();
              $('.loginStickyCtaBtn').show();
              $('.user-login-cta').hide();
              $('#productMobileLogout').hide();
              $('#product-dashboard-menu').hide();
            },
            error: function (request, textStatus) {
              console.log('failure', textStatus, request);
            },
          });
        })(jQuery);
      }
    });
  },
  onReady: () => {
    (function () {
      HeaderMenu.onProductLogin();
      // HeaderMenu.fetchUserWalletBalance('cdhaqxf2trkm7qfojjg9heiyskvi2dvx'); // todo remove this after testing - skipdeduction false
      // HeaderMenu.fetchUserWalletBalance('zvuoeuowti8vbnb6mv2d7xdok1oui3ys'); // todo remove this after testing - skipdeduction true
    })(jQuery);
  },
};

window.onProductLogOut = HeaderMenu.onProductLogOut;

export default HeaderMenu;
